import { DrawerHeading, DrawerListSubHeader } from "../Drawer.styled";
import {
  MENU_ROLE_REQUIRED,
  PAGE_COLLECTION_REQUIRED,
  PAGE_ROLE_REQUIRED,
} from "../../../constants/access";

import { DRAWER_MENU } from "../../../constants/menu";
import { Divider } from "@mui/material";
import { DrawerSectionProps } from "../../../types/DrawerSection";
import EnsureUserHasAccess from "../../../security/EnsureUserHasAccess";
import MenuItem from "../../Menu/MenuItem";
import { useTranslation } from "react-i18next";

const Admin = ({ open }: DrawerSectionProps) => {
  const { t } = useTranslation();

  return (
    <EnsureUserHasAccess
      roles={MENU_ROLE_REQUIRED.ADMIN}
      roleStrategy="any"
      redirect={false}
    >
      <DrawerHeading sx={{ ...(open && { p: 0 }) }}>
        {open ? (
          <DrawerListSubHeader>{t("admin_label")}</DrawerListSubHeader>
        ) : null}

        <EnsureUserHasAccess
          collections={PAGE_COLLECTION_REQUIRED.ACCESS_MANAGEMENT}
          roles={PAGE_ROLE_REQUIRED.ACCESS_MANAGEMENT}
          roleStrategy="any"
          redirect={false}
        >
          <MenuItem open={open} element={DRAWER_MENU.ACCESS_MANAGEMENT} />
        </EnsureUserHasAccess>

        <EnsureUserHasAccess
          roles={PAGE_ROLE_REQUIRED.DATABASE}
          redirect={false}
        >
          <MenuItem open={open} element={DRAWER_MENU.DATABASE_MANAGEMENT} />
        </EnsureUserHasAccess>
      </DrawerHeading>
      {!open ? <Divider /> : null}
    </EnsureUserHasAccess>
  );
};

export default Admin;
